var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3841_184)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path2",
    x: 3,
    y: 5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#1E428A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "white",
    strokeWidth: 4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Path3",
    x: 1,
    y: 3,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "#1E428A",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3841_184"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioFill);
export default __webpack_public_path__ + "static/media/Radio_fill.08de5dce00c7cf1e5a5c344b5f5469dd.svg";
export { ForwardRef as ReactComponent };